import FilterOption from '../domain/FilterOption'

const TEALIUM_CODES = {
  [FilterOption.FREE_CANCELLATION]: 'CAN',
  [FilterOption.POINTS]: 'POI',
  [FilterOption.BREAKFAST]: 'BF',
  [FilterOption.ACCESSIBLE_ROOMS]: 'ACC',
  [FilterOption.PACKAGES]: 'PACK'
}

export default class NewRdTrackingService {
  trackFilter(filter) {
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents.RATE_FILTER_APPLIED, {
        filters: filter.options
          .filter(o => o.selected)
          .map(o => TEALIUM_CODES[o.code])
          .join(',')
      })
    )
  }

  trackCurrency(selectedCurrency, lowestPricePerCategory) {
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents.SELECT_NEW_CURRENCY, {
        lowestPrice: {
          currency: selectedCurrency.code,
          price: lowestPricePerCategory
        }
      })
    )
  }
}
